import React from 'react';
import { Pressable } from 'react-native';
import { radius, useColors } from '../theme';
import { Icon } from '../icons/Icon';
import type { IconName } from '../icons/Icon';
import { T } from './Text';

/** Category filter pill. */
export function Chip({
  label,
  icon,
  active,
  onPress,
}: {
  label: string;
  icon?: IconName;
  active: boolean;
  onPress: () => void;
}) {
  const colors = useColors();
  const fg = active ? colors.onGold : colors.textDim;
  return (
    <Pressable
      onPress={onPress}
      style={({ hovered }: any) => ({
        flexDirection: 'row',
        alignItems: 'center',
        gap: 7,
        paddingVertical: 8,
        paddingHorizontal: 14,
        borderRadius: radius.pill,
        borderWidth: 1,
        backgroundColor: active ? colors.gold : colors.surface,
        borderColor: active ? colors.gold : hovered ? colors.goldDim : colors.line,
      })}
    >
      {icon ? <Icon name={icon} size={14} color={fg} /> : null}
      <T size={12.5} weight={600} color={fg}>
        {label}
      </T>
    </Pressable>
  );
}
